// @flow
import feathers from '@feathersjs/client';
import rest from '@feathersjs/client/rest';
import type { ClientType /*JwtPayloadType, ClientServiceType, EntityType*/ } from './flowTypes';
import invariant from 'invariant';
import appHooks from './app.hooks';

export default async function feathersClient(apiServer: string): Promise<ClientType> {
  invariant(apiServer, 'API server is not set');
   
  const app = feathers();
  const restClient = rest(apiServer);
  app.configure(restClient.fetch(window.fetch));  
  
  app.hooks(appHooks);
  return app;
}



// WEBPACK FOOTER //
// ./src/application/client/feathersClient.js